import {
    CardinityCreatePaymentRequest,
    CardinityCreatePaymentResponse,
    CardinityFinalizeRequest,
    CardinityFinalizeResponse,
    CardinityTransaction,
} from '@lib/domain/payment/cardinity';
import { HTTPService } from '../HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class CardinityService {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async purchaseOrderCardinity(
        body: CardinityCreatePaymentRequest,
    ): Promise<CardinityCreatePaymentResponse> {
        const url = 'order/cardinity-purchase-order';
        const { data } = await this.httpService.post({
            url,
            data: body,
        });
        return data;
    }

    async finalizePendingCardinity(
        body: CardinityFinalizeRequest,
    ): Promise<CardinityFinalizeResponse> {
        const url = 'order/finalize-pending-cardinity';
        const { data } = await this.httpService.post({
            url,
            data: body,
        });
        return data;
    }

    async getTransactionDetails(
        orderId: string,
    ): Promise<CardinityTransaction | null> {
        const { data } = await this.httpService.get({
            url: `payment/cardinity/${orderId}`,
        });
        return data;
    }
}
